export const POST_GEO = 'POST_GEO';
export const LIST_GEO = 'LIST_GEO';
export const GET_GEO = 'GET_GEO';
export const GET_GEO_BREADCRUMBS = 'GET_GEO_BREADCRUMBS';
